import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useRegisterStatus } from '../../../hooks/useRegisterStatus';

const RegistrationGuard = ({ children }) => {
  const { registerInfo, isLoading } = useRegisterStatus();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 로딩 중이거나 registerInfo가 없으면(아직 서버로부터 호출 값이 없으면) 로직 실행하지마
    if (isLoading || !registerInfo) return;

    const { isChildRegistered, isVoiceRegistered } = registerInfo;
    const isAllowed = isChildRegistered && isVoiceRegistered;

    if (!isAllowed) {
      const timer = setTimeout(() => {
        let message = '';
        let targetPath = '';

        if (!isChildRegistered) {
          message = '아이 등록이 필요한 서비스입니다. 지금 등록하러 갈까요?';
          targetPath = '/mypage/child-register';
        } else if (!isVoiceRegistered) {
          message = '아이 음성 등록이 필요한 서비스입니다. 지금 등록하러 갈까요?';
          targetPath = '/mypage/voice-register';
        }

        // 확인을 누른 경우: 등록 페이지로 이동
        if (window.confirm(message)) {
          navigate(targetPath, { replace: true });
        } else {
          /* 취소를 누른 경우
             히스토리에 이전 기록이 있다면 뒤로(-1), 없다면 홈(/)으로 이동 */
          if (window.history.length > 1) {
            navigate(-1, { replace: true });
          } else {
            navigate('/', { replace: true });
          }
        }
      }, 10);

      return () => clearTimeout(timer);
    }
  }, [isLoading, registerInfo, location.key, navigate]);

  // 로딩 중이면 화면 띄우지 마
  if (isLoading) return null;

  const isAllowed  = registerInfo?.isChildRegistered && registerInfo?.isVoiceRegistered;
  return isAllowed  ? <>{children}</> : null;
};

export default RegistrationGuard;